import { CharmSelectionType } from '../ComposeTypes';

export function getCharmSelectionTypeName(type: CharmSelectionType): string {
    switch (type) {
        case CharmSelectionType.None:
            return 'None';
        case CharmSelectionType.Automatic:
            return 'Automatic';
        case CharmSelectionType.Suggestion:
            return 'Suggestion';
        case CharmSelectionType.Manual:
            return 'Manual';
        default:
            return '';
    }
}

export default getCharmSelectionTypeName;
